import { render } from "./MainTheme.vue?vue&type=template&id=98bd7d92&ts=true"
import script from "./MainTheme.vue?vue&type=script&lang=ts"
export * from "./MainTheme.vue?vue&type=script&lang=ts"

import "./MainTheme.vue?vue&type=style&index=0&id=98bd7d92&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__